import { theme } from "@chakra-ui/core";

// Let's say you want to add custom colors
const customTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    primary: {
      "100": "#EAEAF7",
      "200": "#D6D6EE",
      "300": "#AFAFCF",
      "400": "#80809F",
      "500": "#47475F",
      "600": "#333351",
      "700": "#232344",
      "800": "#161637",
      "900": "#0D0D2D",
      "transparent-100": "rgba(71, 71, 95, 0.08)",
      "transparent-200": "rgba(71, 71, 95, 0.16)",
      "transparent-300": "rgba(71, 71, 95, 0.24)",
      "transparent-400": "rgba(71, 71, 95, 0.32)",
      "transparent-500": "rgba(71, 71, 95, 0.4)",
      "transparent-600": "rgba(71, 71, 95, 0.48)",
      "transparent-700": "rgba(71, 71, 95, 0.78)",
      "transparent-800": "rgba(71, 71, 95, 0.88)",      
        },
    success: {
      "100": "#D1FACE",
      "200": "#A0F6A3",
      "300": "#6CE37C",
      "400": "#45C964",
      "500": "#15A545",
      "600": "#0F8D45",
      "700": "#0A7643",
      "800": "#065F3E",
      "900": "#044F3A",
      "transparent-100": "rgba(21, 165, 69, 0.08)",
      "transparent-200": "rgba(21, 165, 69, 0.16)",
      "transparent-300": "rgba(21, 165, 69, 0.24)",
      "transparent-400": "rgba(21, 165, 69, 0.32)",
      "transparent-500": "rgba(21, 165, 69, 0.4)",
      "transparent-600": "rgba(21, 165, 69, 0.48)",
    },    
    info: {
      "100": "#D3E7FE",
      "200": "#A8CDFD",
      "300": "#7BAEFA",
      "400": "#5A93F5",
      "500": "#2669EF",
      "600": "#1B50CD",
      "700": "#133BAC",
      "800": "#0C298A",
      "900": "#071C72",
      "transparent-100": "rgba(38, 105, 239, 0.08)",
      "transparent-200": "rgba(38, 105, 239, 0.16)",
      "transparent-300": "rgba(38, 105, 239, 0.24)",
      "transparent-400": "rgba(38, 105, 239, 0.32)",
      "transparent-500": "rgba(38, 105, 239, 0.4)",
      "transparent-600": "rgba(38, 105, 239, 0.48)",
    },
    warning: {
      "100": "#FFF7CC",
      "200": "#FFEE99",
      "300": "#FFE266",
      "400": "#FFD63F",
      "500": "#FFC300",
      "600": "#DBA200",
      "700": "#B78300",
      "800": "#936600",
      "900": "#7A5100",
      "transparent-100": "rgba(255, 195, 0, 0.08)",
      "transparent-200": "rgba(255, 195, 0, 0.16)",
      "transparent-300": "rgba(255, 195, 0, 0.24)",
      "transparent-400": "rgba(255, 195, 0, 0.32)",
      "transparent-500": "rgba(255, 195, 0, 0.4)",
      "transparent-600": "rgba(255, 195, 0, 0.48)",
    },   
    danger: {
      "100": "#FCDCD2",
      "200": "#FAB2A7",
      "300": "#F07D78",
      "400": "#E1555C",
      "500": "#CE233C",
      "600": "#B1193D",
      "700": "#94113D",
      "800": "#770B39",
      "900": "#620636",
      "transparent-100": "rgba(206, 35, 60, 0.08)",
      "transparent-200": "rgba(206, 35, 60, 0.16)",
      "transparent-300": "rgba(206, 35, 60, 0.24)",
      "transparent-400": "rgba(206, 35, 60, 0.32)",
      "transparent-500": "rgba(206, 35, 60, 0.4)",
      "transparent-600": "rgba(206, 35, 60, 0.48)"
    },              
  },
  fonts: {
    body: "system-ui, sans-serif",
    heading: "Montserrat, sans-serif",
    mono: "Menlo, monospace",
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700,
    bolder: 900,
  },  
};

export default customTheme;